module.exports = __webpack_public_path__ + "static/media/Export_Light.c25b8074.svg";